export default __webpack_public_path__ + "static/media/docs-image-02.8872eb07.png";